// extracted by mini-css-extract-plugin
export default {"FooterPrivacy":"JxW6E","FooterPrivacyLink":"JahP_"};